<ngx-mat-timepicker name="json"
                    [disabled]="readOnly"
                    [ngModel]="momentValue"
                    (ngModelChange)="onValueChanged($event)"
                    [defaultTime]="[0,0,0]"
                    [enableMeridian]="true"></ngx-mat-timepicker>